import React, {useState} from 'react';
import 'react-phone-number-input/style.css'
import './GuestProtection.css'
import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
//import JoinPriorityWaitlistBtn from '../../ViralLoops/JoinPriorityWaitlistBtn';

const GuestProtection = () => {
    const [showWaitlist, setShowWaitlist] = useState(false);
    return(
        <>
            <section className='guestProtectionlMain' id='GuestProtectionPlans'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-8 col-md-12 col-sm-12 col-12'>
                            <div className='guestProtectionhead'>
                                <h2>Guest Protection Plans <span> safeguard every renter and trip</span></h2>
                                <p>Choose a Rentid Protection Plan <span>up until the trip start time online or from the app. </span>
                                    Our plans provide peace of mind by covering unexpected incidents ensuring confidence for every rental.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='guestProtectionInner'>
                        <div className='row justify-content-center'>
                            <div className='col-xl-4 col-lg-6 col-md-12 col-sm-12'>
                                <div className='plansInner plansInner_1'>
                                    <img className="img-fluid" width="73px" src="/img/rentshield/tick_01.svg" alt="icon" />
                                    <h3>Basic<span> Protection</span></h3>
                                    <p>Does not cover damage to your vehicle</p>
                                    <h4> State Mandated Liability Coverage </h4>
                                    <ul>
                                        <li>Property Damage to others vehicle</li>
                                        <li>Property Damage to others property.</li>
                                        <li>Bodily Injury to other persons.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-xl-4 col-lg-6 col-md-12 col-sm-12'>
                                <div className='plansInner plansInner_2'>
                                    <img className="img-fluid" width="62px" src="/img/rentshield/tick_security.svg" alt="icon" />
                                    <h3>Premier<span> Protection</span></h3>
                                    <p>Covers damage to your vehicle</p>
                                    <h4>Liability + Physical Damage Coverage</h4>
                                    <ul>
                                        <li>State required liability insurance</li>
                                        <li>Physical damage coverage for up to $110,000 or ACV*</li>
                                        <li>Supplemental Liability Protection up to $1 million</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className="planBtn">
                                <p className="plansPara_2">Deductibles for physical damage claims range from  $2500.00 to $5000.00 out of pocket.</p>
                                {/* <Link className="btn" to="/rentshield?signup=waitlist">Join Waitlist <img src="/img/rentshield/arrow_white.svg" alt="Join Waitlist icon" /></Link> */}
                                <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                            <button onClick={() => setShowWaitlist(true)} className="btn">
                                Join Waitlist <img src="/img/rentshield/arrow_white.svg" alt="Join Waitlist icon" />
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default GuestProtection;